import { getRobots } from "../results/selectors";

export const robotsMiddleware = () => store => next => action => {

  next(action);
  if (action.meta && action.meta.updateRobots) {
    const state = store.getState();
    const robots = getRobots(state);
    if (robots) {
      const robotsTag = document.querySelector('meta[name="robots"]');
      if (robotsTag === null) {
        var linkNode = document.createElement('meta');
        linkNode.setAttribute('name', 'robots');
        linkNode.setAttribute('content', robots);
        document.querySelector('head').appendChild(linkNode);
      } else {
        robotsTag.setAttribute('content', robots);
      }
    }
  }
}